import { useMemo } from 'react'
import { Spinner } from '@heroui/spinner'
import { PLACEHOLDER_IMAGE } from '@bm-js/atlascloud-shared'

interface Props extends React.ImgHTMLAttributes<HTMLImageElement> {
  isLoading?: string
}

const ImageWithLoader = (props: Props) => {
  const { loading, src, ...imageProps } = props

  const displayLoader = useMemo(() => {
    return loading || !src
  }, [loading, src])

  return (
    <div className='flex justify-start text-primary-400'>
      <div className='relative'>
        <img {...imageProps} src={src || PLACEHOLDER_IMAGE} />
        <div
          className={`absolute inset-0 grid place-items-center transition-opacity ${
            displayLoader ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <Spinner color='current' />
        </div>
      </div>
    </div>
  )
}

export default ImageWithLoader
